'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.watchLocationChangeFactory = exports.watchCrudActionsFactory = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _adminOnRest = require('admin-on-rest');

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _buildAorAction = require('./buildAorAction');

var _buildAorAction2 = _interopRequireDefault(_buildAorAction);

var _createApolloQueryChannel = require('./createApolloQueryChannel');

var _createApolloQueryChannel2 = _interopRequireDefault(_createApolloQueryChannel);

var _getWatchOptionsForQuery = require('./getWatchOptionsForQuery');

var _getWatchOptionsForQuery2 = _interopRequireDefault(_getWatchOptionsForQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var watchCrudActionsFactory = exports.watchCrudActionsFactory = function watchCrudActionsFactory(apolloConfiguredClient, apolloWatchOptions) {
    return _regenerator2.default.mark(function watchCrudActions(action) {
        var watchOptions, params, _action$meta, fetchType, resource, watcher, apolloQueryChannel, parsedApolloQueryResult, type, payload, meta, aorAction;

        return _regenerator2.default.wrap(function watchCrudActions$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _effects.call)(_getWatchOptionsForQuery2.default, apolloWatchOptions, action);

                    case 2:
                        watchOptions = _context.sent;
                        params = action.payload, _action$meta = action.meta, fetchType = _action$meta.fetch, resource = _action$meta.resource;
                        _context.next = 6;
                        return (0, _effects.call)(apolloConfiguredClient.watchRequest, fetchType, resource, params, watchOptions);

                    case 6:
                        watcher = _context.sent;
                        _context.next = 9;
                        return (0, _effects.call)(_createApolloQueryChannel2.default, watcher);

                    case 9:
                        apolloQueryChannel = _context.sent;

                    case 10:
                        if (!true) {
                            _context.next = 26;
                            break;
                        }

                        _context.next = 13;
                        return (0, _effects.take)(apolloQueryChannel);

                    case 13:
                        parsedApolloQueryResult = _context.sent;
                        type = action.type, payload = action.payload, meta = action.meta;
                        _context.next = 17;
                        return [(0, _effects.put)({ type: type + '_LOADING', payload: payload, meta: (0, _lodash2.default)(meta, 'fetch') }), (0, _effects.put)({ type: _adminOnRest.FETCH_START })];

                    case 17:
                        _context.next = 19;
                        return (0, _effects.call)(_buildAorAction2.default, action, parsedApolloQueryResult);

                    case 19:
                        aorAction = _context.sent;
                        _context.next = 22;
                        return (0, _effects.put)(aorAction);

                    case 22:
                        _context.next = 24;
                        return (0, _effects.put)({ type: _adminOnRest.FETCH_END });

                    case 24:
                        _context.next = 10;
                        break;

                    case 26:
                    case 'end':
                        return _context.stop();
                }
            }
        }, watchCrudActions, this);
    });
};

var watchLocationChangeFactory = exports.watchLocationChangeFactory = function watchLocationChangeFactory(watchCrudActions) {
    return _regenerator2.default.mark(function watchLocationChange() {
        return _regenerator2.default.wrap(function watchLocationChange$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _effects.takeLatest)([_adminOnRest.CRUD_GET_LIST, _adminOnRest.CRUD_GET_ONE], watchCrudActions);

                    case 2:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, watchLocationChange, this);
    });
};

exports.default = function (apolloConfiguredClient, apolloWatchOptions) {
    return _regenerator2.default.mark(function aorGraphQlSaga() {
        var watchCrudActions;
        return _regenerator2.default.wrap(function aorGraphQlSaga$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        watchCrudActions = watchCrudActionsFactory(apolloConfiguredClient, apolloWatchOptions);
                        _context3.next = 3;
                        return (0, _effects.takeLatest)(_reactRouterRedux.LOCATION_CHANGE, watchLocationChangeFactory(watchCrudActions));

                    case 3:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, aorGraphQlSaga, this);
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/realtime/saga.js
// module id = 945
// module chunks = 0